import { CreateToastFnReturn } from '@chakra-ui/react';

import {
  ExternalAppsEnum,
  ExternalAppsLabelsEnum,
} from '../enums/ExternalAppsEnum';

import { setupApi } from './api';

export async function redirectToExternalAppWithToken(
  appKey: ExternalAppsEnum,
  toast?: CreateToastFnReturn
): Promise<void> {
  try {
    const { data } = await setupApi().post<{ redirectUrl: string }>(
      '/auth/redirect-token',
      {
        appKey,
      }
    );

    window.open(data.redirectUrl, '_blank');
  } catch {
    toast?.({
      title: 'Ops!',
      description: `Não foi possível redirecionar para o ${ExternalAppsLabelsEnum[appKey]}.`,
      status: 'error',
    });
  }
}
